export default __webpack_public_path__ + "static/media/essencedetonation.0341bc9e.png";